const companyCodes = {
    'oztabak': 'oztabak-tr-14',
} 

export {
    companyCodes, 
}